// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { styled } from '@mui/material/styles';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Card, Typography } from '../../../lib/base';
import { PageError } from '../error';
import { PageLoading } from '../loading';

// Used in ExpandoCard
export const StyledCardHeader = styled('div', {
  shouldForwardProp: (prop) => prop !== 'pointer' && prop !== 'sx',
})<{ readonly id?: string; readonly pointer?: boolean }>(({ theme, pointer }) => ({
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
  },
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  justifyContent: 'space-between',
  paddingBottom: theme.spacing(2),
  paddingTop: theme.spacing(2),
  cursor: pointer ? 'pointer' : undefined,
}));

// Used in ExpandoCard
export const StyledCardFirst = styled('div')(() => ({
  width: '100%',
  flex: '1 1 auto',
}));

interface Props {
  readonly title: string;
  readonly rightElement: React.JSX.Element;
  readonly content: React.JSX.Element;
  readonly id?: string;
  readonly extraHeaderContent?: React.JSX.Element;
  readonly loading?: boolean;
  readonly loadingError?: boolean;
}

export default function TitleCard({
  title,
  id,
  rightElement,
  content,
  loading,
  loadingError,
  extraHeaderContent,
}: Props) {
  return (
    <StyledCardFirst id={id}>
      <Card sx={{ display: 'flex', flexDirection: 'column' }}>
        <StyledCardHeader>
          <Typography variant="h6">{title}</Typography>
          {rightElement}
        </StyledCardHeader>
        {extraHeaderContent && <StyledCardHeader>{extraHeaderContent}</StyledCardHeader>}
        {loading ? <PageLoading /> : loadingError ? <PageError /> : content}
      </Card>
    </StyledCardFirst>
  );
}
